/**
 * @generated SignedSource<<c0ae1f0852a58af457682ceab770f3e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type calendarCardSummary_calendar$data = {
  readonly summaryField: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "calendarCardSummary_calendar";
};
export type calendarCardSummary_calendar$key = {
  readonly " $data"?: calendarCardSummary_calendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"calendarCardSummary_calendar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "calendarCardSummary_calendar",
  "selections": [
    {
      "concreteType": "JiraSingleLineTextField",
      "kind": "LinkedField",
      "name": "summaryField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "text"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "fa779f29634aee32ceebc71c6a8f642a";

export default node;
